import styled, { css, keyframes } from 'styled-components';

const slideUp = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 50;
  animation: ${fadeIn} 0.2s ease-out forwards;
`;

export const DrawerContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 80vh;
  background: white;
  border-radius: 1.5rem 1.5rem 0 0;
  z-index: 51;
  display: flex;
  flex-direction: column;
  animation: ${slideUp} 0.3s ease-out forwards;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
`;

export const HandleBar = styled.div`
  display: flex;
  justify-content: center;
  padding: 0.75rem 0;
  cursor: pointer;

  &::after {
    content: '';
    width: 2.5rem;
    height: 0.25rem;
    background: #cbd5e1;
    border-radius: 9999px;
  }
`;

export const DrawerContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
`;

export const TabsWrapper = styled.div`
  display: flex;
  overflow-x: auto;
  padding: 0.5rem;
  gap: 0.25rem;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  flex-shrink: 0;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

type TabButtonProps = {
  $active?: boolean;
};

export const TabButton = styled.button<TabButtonProps>`
  ${({ $active }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;
    padding: 0.5rem 0.75rem;
    border-radius: 0.5rem;
    font-size: 0.75rem;
    font-weight: 500;
    white-space: nowrap;
    transition: all 0.2s ease;
    background: ${$active ? '#eef2ff' : 'transparent'};
    color: ${$active ? '#4f46e5' : '#64748b'};
    border: none;
    cursor: pointer;
    position: relative;
    min-width: fit-content;

    &:hover {
      background: ${$active ? '#eef2ff' : '#f1f5f9'};
    }

    svg {
      width: 1rem;
      height: 1rem;
    }
  `};
`;

export const Badge = styled.span`
  min-width: 1rem;
  height: 1rem;
  padding: 0 0.25rem;
  background: #ef4444;
  color: white;
  font-size: 0.5625rem;
  font-weight: 600;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ContentWrapper = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;
